import { Observable, Subject } from 'rxjs';

import { SnAlarm } from '@lib/api/entities';

export class SnAlprTracking {
  private readonly _alprMap = new Map<string, number>();

  private readonly _alprCreated$ = new Subject<SnAlarm>();
  private readonly _alprUpdated$ = new Subject<SnAlarm>();
  private readonly _alprRemoved$ = new Subject<SnAlarm>();

  constructor() {}

  get alprCreated$(): Observable<SnAlarm> {
    return this._alprCreated$.asObservable();
  }

  get alprUpdated$(): Observable<SnAlarm> {
    return this._alprUpdated$.asObservable();
  }

  get alprRemoved$(): Observable<SnAlarm> {
    return this._alprRemoved$.asObservable();
  }

  public addAlpr(data: any, autoplay: boolean = false, emitEvent: boolean = true): void {
    this.setAlprCount(data.message);
    const alarm = new SnAlarm(data);
    alarm.autoplay = autoplay;
    if (emitEvent) {
      this._alprCreated$.next(alarm);
    }
  }

  public removeAlpr(data: any): void {
    const alarm = new SnAlarm(data);
    this._alprMap.delete(data.message);
    this._alprMap.set(data.message, 0);
    this._alprRemoved$.next(alarm);
  }

  public hasAlpr(id: string): boolean {
    return this._alprMap.has(id);
  }

  public updateAlpr(data: any): void {
    this.addAlpr(data);
  }

  public destroy(): void {
    this._alprCreated$.complete();
    this._alprUpdated$.complete();
    this._alprRemoved$.complete();
  }

  public setAlprCount(message: string): void {
    if (!this._alprMap.has(message)) {
      this._alprMap.set(message, 0);
    }
    this._alprMap.set(message, this._alprMap.get(message) + 1);
  }

  public getAlprCount(message: string): number {
    return this._alprMap.get(message);
  }
}
